import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import scrollToTop from "../components/hooks/ScrollToTop";
import './css/templates.css';

// Term And Condition component

const TermsAndCondition = () => {
  const { t } = useTranslation();

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
  }, [])

  return (
    <div >
      <div className="page-wrapper">
        <Navbar />
        <section className="blog-area">
          <div className="hero-wrapper hero-7 space" id="hero">
            <div className="container-space">
              <div className="row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper">
                <div className="col-lg-12 col-md-6">
                  <h3
                    className="text-center links-heading item-heading-font "
                    style={{ fontSize: "26px", color: "#ee7c2c" }}
                  >
                    {t("termsAndConditions")}
                  </h3>
                  <div className="card-text item-content-font">
                    <p
                      style={{ fontSize: "15px" }}
                      className="sl_whiteout notranslate"
                    >
                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theseTermsAndConditions")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("thePurposeOfTheIndependentSoftware")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("changes")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theCompanyMayFromTime")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("consequencesOfDelaysClosures")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theCompanyShallNotBeResponsible")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("provisionsSeverable")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("ifAnyProvisionOfTheIndependent")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("titlesNotSubstantive")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theTitlesAndHeadings")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("waiver")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theCompanyNeverForfeits")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("becomingAnISP")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theRequirementsToBecomeISP")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("usernameIdentiﬁcationAndISPNumber")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("whenTheCompanyReceives")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("iSPBeneﬁts")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("onceTheCompanyAcceptsAnIndependent")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theseBeneﬁtsIncludeTheRight")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <u>
                          <strong>
                            <span style={{ fontSize: "16px" }}>
                              {t("adherenceToCompanyRewardsPlan")}
                            </span>
                          </strong>
                        </u>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("anISPMustAdhere")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("advertisingInGeneral")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPMustAvoidAllDiscourteous")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("allISPMayOnly")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("mediaInquiries")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPMustReferAll")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("trademarksAndCopyrights")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("anISPMayNotUse")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("useOfIndependentSoftware")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("independentSoftwarePartnersconsents")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("tradingProﬁtClaims")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPMustNotMakeClaims")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("incomeClaims")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPsMayNotMakeIncome")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("unauthorizedRecruiting")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("asAnIndependentContractor")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("postCancellationSolicitationProhibited")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("aFormerISPShall")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("downlineGenealogyReports")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theEaconomyDownlineGenealogy")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("corporationPartnershipsAndTrusts")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("aCorporationPartnership")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("deceptivePractices")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPMustFairly")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("independentContractorStatus")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPsAreIndependentContractors")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("international")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPMaySellAndPromote")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("oneISPPerAccount")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("anISPMayOperate")}
                          <Link to="mailto:support@joinnoa.io" className="orange-noa">
                            support@joinnoa.io
                          </Link>
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("saleTransferAssignment")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("anISPMayNotSell")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("separationOfAnISP")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("ifISPsWishToDissolve")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("succession")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("ifAnISPDiesBecomes")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>{t("taxes")}</span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPMustComply")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("telephoneAndEmailSolicitation")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theUseOfAnyAutomated")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPsAreAlsoForbidden")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("territories")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("thereAreNoExclusive")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("tradeShowsAndExpositions")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPMayDisplay")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("transferOfSponsorship")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("everyProspectiveISP")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("changeOfSponsorship")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("eaconomyWillNotPermit")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("responsibilitiesOfIndependent")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("anyISPWhoSponsorsAnother")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("nonDisparagement")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("inSettingTheProper")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("reportingPolicyViolations")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPShouldReport")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("bonusesAndCommissionsBonus")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("eaconomyPaysCommissions")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("adjustmentOfBonuses")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPsEarnCommissions")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("lossOfRightsToCommissions")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("youMustBeActiveISP")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("unclaimedCommissions")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPWhoProvideEaconomy")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("disputeResolutionAndDisciplinary")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("whenAnIndependentSales")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("complianceDepartmentReview")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("uponReceiptOfAWritten")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("mediationAndArbitration")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("allUnresolvedDisputes")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("jurisdictionVenue")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theJurisdictionAndVenue")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("disciplinaryActions")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("violationOfAny")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("independentSoftwarePartner")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("eachISPMustImmediately")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {"additionOfCoApplicants"}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("whenAddingACoApplicant")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("commissionStatementsTaxInvoices")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("commissionStatementsInvoices")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("errorsOrQuestions")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("inTheEventAnISP")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("resolvingProblems")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("ifYouHaveAnyQuestions")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("inactivityAndCancellationPolicies")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPWhoDoNotMeet")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("involuntaryCancellation")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("anISPsViolationOfAny")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("writtenCancellation")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("anISPMayCancel")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("effectOfCancellation")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("followingAnISPsVoluntary")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("definitions")}
                            </span>
                          </u>
                        </strong>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("activeISPAnISP")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPAnIndividualWho")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("iSPUserAgreementThe")}{" "}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("cancellationMayBeEither")}{" "}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("voluntaryCancellationThe")}{" "}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("downlineOrganizationAn")}{" "}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("genealogyReportA")}{" "}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("immediateHouseholdAn")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("levelTheLayersOf")}{" "}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("ofﬁcialEaconomyMaterial")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("sponsorAnISPWho")}{" "}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("uplineTheTermRefers")}
                        </span>
                      </p>

                      <p className="agreement-para">
                        <strong>
                          <u>
                            <span style={{ fontSize: "16px" }}>
                              {t("eacho")}
                            </span>
                          </u>
                        </strong>
                      </p>
                      <p className="agreement-para">
                        <span style={{ fontSize: "16px" }}>
                          {t("theEachoAppIsProvided")}
                          <Link to="https://portal.joinnoa.io" className="orange-noa">
                            https://portal.joinnoa.io
                          </Link>
                        </span>
                      </p>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default TermsAndCondition;
